import BaseMessageHandler from 'messages/BaseMessageHandler';
import { updateData } from 'actions/getData';

export default class Holdback_List extends BaseMessageHandler {
  success = () => {
    const {
      dispatch,
      message: { payload: { rows } },
    } = this;
    
    dispatch(updateData('holdbacks', {
      items: rows,
    }));
  };
}
